export default "__VITE_ASSET__BxDkvPGM__"